/**
 * Allow users to click on-click elements using the keyboard only
 */
const accessibility = () => {
	window.addEventListener('keydown', function(event) {
		if (event.defaultPrevented) {
			return; // Do nothing if the event was already processed
		} else if (event.key == 'Enter') {
			document.activeElement.click();
		}
	});
};

export default accessibility;
